var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS, useThemeInternal } from "../theme/Theme.js";
/**
 * A component that displays a hyperlink.
 *
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/core/link)
 * @see 🏷️ {@link LinkProps}
 * @see [🤖 OverridableComponent](https://aksel.nav.no/grunnleggende/kode/overridablecomponent) support
 *
 * @example
 * ```jsx
 * <Link href="#">lenke til ny side</Link>
 * <Link as={ReactRouter.Link} to="#">lenke til ny side</Link>
 * ```
 * @example
 * ```jsx
 * <BodyLong>
 * ...
 *  <Link href="#" inlineText>lenke til ny side</Link>
 * ...
 * </BodyLong>
 * ```
 */
export const Link = forwardRef((_a, ref) => {
    var { as: Component = "a", className, underline = true, variant, inlineText = false, "data-color": color } = _a, rest = __rest(_a, ["as", "className", "underline", "variant", "inlineText", "data-color"]);
    const themeContext = useThemeInternal(false);
    const { cn } = useRenameCSS();
    /*
     * We avoid defaulting to "action" in darkside.
     */
    let localVariant;
    if (themeContext === null || themeContext === void 0 ? void 0 : themeContext.isDarkside) {
        localVariant = variant;
    }
    else {
        localVariant = variant !== null && variant !== void 0 ? variant : "action";
    }
    return (React.createElement(Component, Object.assign({ "data-color": color !== null && color !== void 0 ? color : variantToColor(localVariant), "data-variant": localVariant }, rest, { ref: ref, className: cn("navds-link", className, {
            [`navds-link--${localVariant}`]: localVariant,
            "navds-link--remove-underline": !underline,
            "navds-link--inline-text": inlineText,
        }) })));
});
function variantToColor(variant) {
    switch (variant) {
        case "action":
            return "accent";
        case "neutral":
            return "neutral";
        case "subtle":
            return "neutral";
        default:
            return undefined;
    }
}
export default Link;
//# sourceMappingURL=Link.js.map